/**
 * Заголовок вкладки: имя раз за разом проявляется из помех.
 *
 * Цикл идёт непрерывно, но проявленное имя задерживается на глазах: без
 * паузы вкладку нельзя было бы прочитать — она всё время оказывалась бы
 * посреди ряби.
 */

const TITLE = 'CARTEL';

/** Символы помех. Взяты плотные: на фоне букв они видны как рябь. */
const NOISE = '▓▒░█#%&$@/\\|<>*+=-_';

/** Через сколько миллисекунд обновляется кадр. */
const TICK_MS = 45;

/** Сколько кадров ряби приходится на одну проявленную букву. */
const TICKS_PER_LETTER = 3;

/** Сколько имя держится целым, прежде чем осыпаться заново. */
const HOLD_MS = 1400;

/**
 * Один кадр: первые `settled` символов уже на месте, остальные — помехи.
 *
 * Выбор символа помех вынесен в параметр, иначе кадр нельзя проверить: со
 * случайностью внутри тест сравнивал бы результат с самим собой.
 */
export function glitchFrame(
  target: string,
  settled: number,
  noiseAt: (index: number) => number,
): string {
  let out = '';
  for (let i = 0; i < target.length; i += 1) {
    out += i < settled ? target.charAt(i) : NOISE.charAt(noiseAt(i) % NOISE.length);
  }
  return out;
}

/**
 * Запускает проявление и возвращает остановку.
 *
 * При включённом «уменьшении движения» заголовок ставится сразу и навсегда:
 * мигающий текст — одна из вещей, ради которых эту настройку и включают.
 */
export function startTitleGlitch(doc: Document = document): () => void {
  const setStatic = () => {
    doc.title = TITLE;
  };

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    setStatic();
    return () => undefined;
  }

  let timer = 0;
  let stopped = false;

  const noiseAt = () => Math.floor(Math.random() * NOISE.length);

  const reveal = () => {
    let tick = 0;

    const step = () => {
      if (stopped) return;

      const settled = Math.floor(tick / TICKS_PER_LETTER);
      if (settled >= TITLE.length) {
        setStatic();
        timer = window.setTimeout(reveal, HOLD_MS);
        return;
      }

      doc.title = glitchFrame(TITLE, settled, noiseAt);
      tick += 1;
      timer = window.setTimeout(step, TICK_MS);
    };

    step();
  };

  reveal();

  return () => {
    stopped = true;
    window.clearTimeout(timer);
    setStatic();
  };
}
